import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UenService } from './shared/uen.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { Uen } from './shared/uen.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-uen',
  templateUrl: './uen.component.html',
  styleUrls: ['./uen.component.css']
})
export class UenComponent implements OnInit {

  datatable: any;

  ListUEN: Uen[] = [];

  constructor(private uenService:UenService,
    private toastr:ToastrService,
    private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getUEN();
    //his.refreshList();
  }

  getUEN() {
    this.uenService.getUen().then(r => {
      
      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ListUEN = r as Uen[];
      
      this.chRef.detectChanges();

        const table: any = $('table');
        this.datatable = table.DataTable({
          responsive: true
        })

    });
  }

  refreshList(){
    this.uenService.getUen();
  }

  updateUen(){
    this.uenService.updateUen().then(r =>{ this.toastr.success("Ok!");this.refreshList()});
  }
}
